import React from 'react';
import { Search } from 'lucide-react';

interface ResultsCounterProps {
  totalItems?: number;
  from?: number;
  to?: number;
  currentPage?: number;
  loading?: boolean;
  searchText?: string;
  hasFilters?: boolean;
}

const ResultsCounter: React.FC<ResultsCounterProps> = ({
  totalItems = 0,
  from = 0,
  to = 0,
  currentPage = 1,
  loading = false,
  searchText = "",
  hasFilters = false
}) => {
  if (loading) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-200 rounded-lg">
        <Search className="h-4 w-4 text-blue-600" />
        <span className="text-sm text-blue-700">Buscando resultados...</span>
      </div>
    );
  }

  const hasSearch = searchText && searchText.length > 0;
  const showingResults = from > 0 && to > 0;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg">
      <Search className="h-4 w-4 text-gray-600" />
      <div className="text-sm text-gray-700">
        {totalItems === 0 ? (
          <span>
            {hasSearch || hasFilters ? 'No se encontraron resultados' : 'No hay trámites disponibles'}
          </span>
        ) : (
          <span>
            {showingResults ? (
              <>
                Mostrando <strong>{from}-{to}</strong> de <strong>{totalItems}</strong> resultado{totalItems !== 1 ? 's' : ''}
                {hasSearch && <> para "<strong>{searchText}</strong>"</>}
                {hasFilters && !hasSearch && <> con filtros aplicados</>}
                {hasFilters && hasSearch && <> con filtros</>}
              </>
            ) : (
              <>
                <strong>{totalItems}</strong> resultado{totalItems !== 1 ? 's' : ''} encontrado{totalItems !== 1 ? 's' : ''}
                {hasSearch && <> para "<strong>{searchText}</strong>"</>}
                {hasFilters && !hasSearch && <> con filtros aplicados</>}
                {hasFilters && hasSearch && <> con filtros</>}
              </>
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export default ResultsCounter;